import React from "react";
import clsx from "clsx";
import { Box, Button, makeStyles } from "@material-ui/core";
import { NavLink as RouterLink } from "react-router-dom";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { useNavigate } from "react-router-dom";
import { encode } from "js-base64";
import { connect } from "react-redux";
import documentsActions from "src/duck/document/actions";
import globalActions from "src/duck/global/actions";
import { kmMessages } from "src/constant/Messages";

const useStyles = makeStyles((theme) => ({
  root: {},
  toolbarLeftButton: {
    marginRight: theme.spacing(1),
  },
  poperz: {
    zIndex: 1000,
  },
}));

const optionsDoc = [
  { name: "Dodaj katalog", id: 0 },
  { name: "Dodaj dokument", id: 1 },
  { name: "Dodaj wiele dokumentów", id: 2 },
  { name: "Przenieś dokument/katalog", id: 3 },
  { name: "Usuń zaznaczone", id: 4 },
  { name: "Ustaw dostęp publiczny zaznaczonym", id: 5, limited: true },
  { name: "Ustaw dostęp po logowaniu zaznaczonym", id: 6, limited: true },
  { name: "Publikuj zaznaczone", id: 7 },
  { name: "Wycofaj publikację zaznaczonych", id: 8 },
];

const optionsDocParentDraft = [
  { name: "Dodaj katalog", id: 0 },
  { name: "Dodaj dokument", id: 1 },
  { name: "Dodaj wiele dokumentów", id: 2 },
  { name: "Przenieś dokument/katalog", id: 3 },
  { name: "Usuń zaznaczone", id: 4 },
  { name: "Ustaw dostęp publiczny zaznaczonym", id: 5, limited: true },
  { name: "Ustaw dostęp po logowaniu zaznaczonym", id: 6, limited: true },
];

const optionsAttendance = [
  "Rozpocznij potwierdzenia",
  "Zakończ potwierdzenia",
  "Szczegóły potwierdzeń",
];

const Toolbar = ({
  className,
  isAuthorized,
  setMoveSelectedDocuments,
  displaySnackbar,
  parentFolderId,
  dialogHandler,
  attendanceHandler,
  publishHandler,
  unpublishHandler,
  setPublicAccessHandler,
  unsetPublicAccessHandler,
  levelDetails,
  siblingId,
  siblingName,
  moveSelectedDocuments,
  ...rest
}) => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [openDoc, setOpenDoc] = React.useState(false);
  const [openStatus, setOpenStatus] = React.useState(false);
  const anchorRef = React.useRef(null);
  const anchorRefDoc = React.useRef(null);
  const anchorRefStatus = React.useRef(null);
  const navigate = useNavigate();

  const handleMenuItemClick = (event, index) => {
    event.preventDefault();
    attendanceHandler(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const navigateOptionally = (mainPartUrl) => {
    // console.log("NAVIGATE TEST mainPartUrl: " + mainPartUrl);
    // console.log("NAVIGATE TEST siblingId: " + siblingId);
    // console.log("NAVIGATE TEST levelDetails: " + levelDetails);
    // console.log(levelDetails);

    let redirectUrl = siblingId ? `/${mainPartUrl}/${parentFolderId}/${siblingId}/${encode(
      siblingName,
      true
    )}` : `/${mainPartUrl}/${parentFolderId}`

    const lastItem = levelDetails.documentStructNodesBreadCrumps[levelDetails.documentStructNodesBreadCrumps.length - 1];
    const workGroupsIdsString = lastItem.workGroupsIds ? lastItem.workGroupsIds.join(',') : '';

    if (workGroupsIdsString) {
      redirectUrl += `?workGroupsIds=${workGroupsIdsString}`;
    } else if (levelDetails.documentStructNodesBreadCrumps.length == 1){
      redirectUrl += `?rootLevel=true`;
    }
  
    navigate(redirectUrl);
  };

  const moveDocumentFolderHandler = () => {
    if (moveSelectedDocuments?.length > 0) {
      let firstStatus = moveSelectedDocuments[0].status;
      let firstPublicAccess = moveSelectedDocuments[0].publicAccess;

      let selectedVotings = moveSelectedDocuments.filter(
        (moveSelectedDocument) => moveSelectedDocument?.votings?.length > 0
      );

      if (selectedVotings?.length > 0) {
        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 3000,
          message: kmMessages.info.document.voting_move,
        });
      } else {
        let allTheSame = moveSelectedDocuments.every(
          (doc) =>
            doc.status === firstStatus && doc.publicAccess === firstPublicAccess
        );

        if (allTheSame) {
          setMoveSelectedDocuments(moveSelectedDocuments);
          navigate(`/przenieskatalogdokument/${parentFolderId}`);
        } else {
          displaySnackbar({
            isOpen: true,
            severity: "error",
            autoHideDuration: 3000,
            message: kmMessages.info.document.moving_status,
          });
        }
      }
    } else {
      displaySnackbar({
        isOpen: true,
        severity: "error",
        autoHideDuration: 3000,
        message: kmMessages.info.document.moving_not_selected,
      });
    }
  };

  const handleDocMenuItemClick = (event, menuIndex) => {
    event.preventDefault();
    setOpenDoc(false);
    switch (menuIndex) {
      case 0:
        navigateOptionally("nowykatalog");
        break;
      case 1:
        navigateOptionally("nowydokument");
        break;
      case 2:
        navigateOptionally("dodajwieledok");
        break;
      case 3:
        moveDocumentFolderHandler();
        break;
      case 4:
        dialogHandler();
        break;
      case 5:
        setPublicAccessHandler();
        break;
      case 6:
        unsetPublicAccessHandler();
        break;
      case 7:
        publishHandler();
        break;
      case 8:
        unpublishHandler();
        break;
      default:
        break;
    }
  };

  const handleDocToggle = () => {
    setOpenDoc((prevDocOpen) => !prevDocOpen);
  };

  const handleDocClose = (event) => {
    if (anchorRefDoc.current && anchorRefDoc.current.contains(event.target)) {
      return;
    }

    setOpenDoc(false);
  };

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      {isAuthorized ? (
        <Box display="flex" justifyContent="flex-end" flexWrap="wrap">
          <Box mb={1}>
            <ButtonGroup
              variant="contained"
              color="primary"
              ref={anchorRefDoc}
              className={classes.toolbarLeftButton}
              aria-label="Dodaj w katalogu"
            >
              <Button component="span" onClick={handleDocToggle}>
                Katalog / Dokument
              </Button>
              <Button
                color="primary"
                size="small"
                aria-controls={openDoc ? "split-button-menu" : undefined}
                aria-expanded={openDoc ? "true" : undefined}
                aria-label="wybierz co chcesz dodać"
                aria-haspopup="menu"
                onClick={handleDocToggle}
              >
                <ArrowDropDownIcon />
              </Button>
            </ButtonGroup>
            <Popper
              open={openDoc}
              anchorEl={anchorRefDoc.current}
              role={undefined}
              className={classes.poperz}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleDocClose}>
                      <MenuList id="split-button-menu">
                        {levelDetails.status === "published"
                          ? optionsDoc.map((option, index) =>
                              option.limited && !levelDetails.publicAccess ? (
                                <></>
                              ) : (
                                <MenuItem
                                  key={option.id}
                                  onClick={(event) =>
                                    handleDocMenuItemClick(event, option.id)
                                  }
                                >
                                  {option.name}
                                </MenuItem>
                              )
                            )
                          : optionsDocParentDraft.map((option, index) =>
                              option.limited && !levelDetails.publicAccess ? (
                                <></>
                              ) : (
                                <MenuItem
                                  key={option.id}
                                  onClick={(event) =>
                                    handleDocMenuItemClick(event, option.id)
                                  }
                                >
                                  {option.name}
                                </MenuItem>
                              )
                            )}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>
          <Box mb={1}>
            <Button
              color="primary"
              variant="contained"
              component={RouterLink}
              className={classes.toolbarLeftButton}
              to={`/powiadomieniedokumenty/${parentFolderId}`}
            >
              Wyślij powiadomienie
            </Button>
          </Box>
          {parentFolderId > 1 ? (
            <Box>
              <ButtonGroup
                variant="contained"
                color="primary"
                ref={anchorRef}
                className={classes.toolbarLeftButton}
                aria-label="split button"
              >
                <Button component="span" onClick={handleToggle}>
                  Potwierdzenia uczestnictwa
                </Button>
                <Button
                  color="primary"
                  size="small"
                  aria-controls={open ? "split-button-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-label="select merge strategy"
                  aria-haspopup="menu"
                  onClick={handleToggle}
                >
                  <ArrowDropDownIcon />
                </Button>
              </ButtonGroup>
              <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                className={classes.poperz}
                transition
                disablePortal
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === "bottom" ? "center top" : "center bottom",
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList id="split-button-menu">
                          {optionsAttendance.map((option, index) => (
                            <MenuItem
                              key={option}
                              disabled={
                                (index === 0 &&
                                  levelDetails.attendanceCheckingActive) ||
                                (index === 1 &&
                                  !levelDetails.attendanceCheckingActive)
                              }
                              onClick={(event) =>
                                handleMenuItemClick(event, index)
                              }
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </Box>
          ) : (
            <></>
          )}

          {/* <Button color="secondary" variant="contained" onClick={dialogHandler}>
            Usuń zaznaczone
          </Button> */}
        </Box>
      ) : (
        <></>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setMoveSelectedDocuments: (moveSelectedDocuments) =>
    dispatch(documentsActions.setMoveSelectedDocuments(moveSelectedDocuments)),
  displaySnackbar: (snackBarParameters) =>
    dispatch(globalActions.displaySnackbar(snackBarParameters)),
});

export default connect(null, mapDispatchToProps)(Toolbar);
